module.exports = {
  primaryColor: '#1264de',
  secondaryColor: '#061f3d'
};
